<template>
  <div>
    <b-row>
      <b-col cols="2">
        <div style="margin: 5px;">{{ StoreLangTranslation.data['data_layers'][StoreLang] }}</div>
        <div style="height: 500px; overflow-y: auto;">
          <template v-for="layer_code in d_layerCodeList">
            <div :style="layer_code === d_selectedLayerCode ? 'cursor: pointer; margin:3px; padding: 4px; background-color: #9ee2ff;' : 'cursor: pointer; margin:3px; padding: 4px; background-color: #f5f5f5; white-space: nowrap;'" @click="f_selectLayerCode(layer_code)">
              <span :style="layer_code === d_selectedLayerCode ? 'font-weight: bolder; margin: 3px;' : 'margin: 3px;'">{{ layer_code }}</span>
            </div>
          </template>
        </div>
      </b-col>
      <b-col cols="10">
        
        <div style="margin-bottom: 5px">
          <b-button :disabled="d_selectedLayerCode && d_selectedWdm ? false : true" @click="f_openSearchRuleModal()" variant="primary">{{ StoreLangTranslation.data['create_query_rule'][StoreLang] }}</b-button>
          <b-button v-if="d_algorithmShow" :disabled="d_selectedLayerCode && d_selectedWdm ? false : true" @click="f_changeAlgorithmShow(false)" variant="secondary" style="margin-left: 5px;"><i class="fa fa-eye"></i></b-button>
          <b-button v-else :disabled="d_selectedLayerCode && d_selectedWdm ? false : true" @click="f_changeAlgorithmShow(true)" variant="secondary" style="margin-left: 5px;"><i class="fa fa-eye-slash"></i></b-button>
          <b-button :disabled="d_selectedLayerCode && d_selectedWdm ? false : true" @click="f_editWdmrDocument()" style="float: right;" variant="success">{{ StoreLangTranslation.data['new_data'][StoreLang] }}</b-button>
        </div>
        <div v-if="d_algorithmShow">
          <template v-if="d_dbQueryRule.query_list && d_dbQueryRule.query_list.length > 0">
            <rule-query :query_list="d_dbQueryRule.query_list" :compile_str="d_dbQueryRule.compile_str_array" :compile_str_date="d_dbQueryRule.compile_str_date" :mode="'view'" :compile_str_text="d_dbQueryRule.compile_str_text"></rule-query>
          </template>
        </div>
        <div v-if="d_dataLoading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <div v-else :style="f_calculateLayerDetailsTableStyle()">
          <table v-if="d_dataList.length > 0 && d_selectedWdm" border="1" align="center" style="table-layout: fixed; overflow-wrap: break-word;">
            <thead>
              <th>
                
              </th>
              <th>
                id
              </th>
              <th>
                client id
              </th>
                <template v-if="d_selectedWdm">
                  <template v-for="pg in d_selectedWdm.param_group.param_order">
                    <template v-for="pr in d_selectedWdm[pg].param_order">
                      <th>
                        {{ d_selectedWdm[pg].parameters[pr].name.label }}
                      </th>
                    </template>
                  </template>
                </template>
            </thead>
            <tbody>
              <tr v-for="(row, row_index) in d_dataList">
                <td style="min-width: 90px">
                  <b-button @click="f_showWdmrDocument(row)" variant="outline-primary" style="margin-right: 5px;"><i class="fa fa-eye"></i></b-button>
                  <b-button @click="f_editWdmrDocument(row)" variant="outline-warning"><i class="fa fa-pencil"></i></b-button>
                </td>
                <td :title="row.id ? row.id : ''">
                  {{ row.id && row.id.length > 20 ? row.id.slice(0, 20) + '...' : row.id }}
                </td>
                <td :title="row.client_id ? row.client_id : ''">
                  <span @click="f_copyClientId(row.client_id)" style="cursor: pointer;">
                    {{ row.client_id && row.client_id.length > 20 ? row.client_id.slice(0, 20) + '...' : row.client_id }}
                  </span>
                </td>
                <template v-for="pg in d_selectedWdm.param_group.param_order">
                  <template v-for="pr in d_selectedWdm[pg].param_order">
                    <template v-if="row['data'] && row['data'][pg] && row['data'][pg][pr] && row['data'][pg][pr]['val']">
                      <template v-if="typeof row['data'][pg][pr]['val'] === 'object'">
                        <td :title="row['data'][pg][pr]['val'].label ? row['data'][pg][pr]['val'].label : ''">
                          {{ row['data'][pg][pr]['val'].label && row['data'][pg][pr]['val'].label.length > 20 ? row['data'][pg][pr]['val'].label.slice(0, 20) + '...' : row['data'][pg][pr]['val'].label }}
                        </td>
                      </template>
                      <template v-else-if="typeof row['data'][pg][pr]['val'] === 'list'">
                        <td>
                          <template v-for="op in row['data'][pg][pr]['val']" :title="op.label ? row['data'][pg][pr]['val'] : ''">
                            {{ op.label && op.label.length > 20 ? op.label.slice(0, 20) + '...' : op.label }}
                          </template>
                        </td>
                      </template>
                      <template v-else>
                        <td :title="row['data'][pg][pr]['val'] ? row['data'][pg][pr]['val'] : ''">
                          {{ row['data'][pg][pr]['val'] && row['data'][pg][pr]['val'].length > 20 ? row['data'][pg][pr]['val'].slice(0, 20) + '...' : row['data'][pg][pr]['val'] }}
                        </td>
                      </template>
                    </template>
                    <template v-else-if="row['data'] && row['data'][pg] && row['data'][pg][pr] && row['data'][pg][pr]['list']">
                      <td style="text-align: center;">
                        <b-button @click="f_showWdmrDocument(row)" variant="outline-primary"><i class="fa fa-eye"></i></b-button>
                      </td>
                    </template>
                    <template v-else>
                      <td></td>
                    </template>
                  </template>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <template v-if="d_dataList.length > 0" v-for="(row, row_index) in d_dataList">
          <b-row style="margin: 30px;">
            <b-col sm="12" lg="1">
              {{ row.id }}
            </b-col>
            <b-col sm="12" lg="1">
              {{ row.client_id }}
            </b-col>
            <b-col sm="12" lg="1">
              {{ row.created_at }}
            </b-col>
            <b-col sm="12" lg="1">
              {{ row.parent_c }}
            </b-col>
            <b-col sm="12" lg="7">
              <template v-if="d_selectedWdm">
                <template v-for="pg in d_selectedWdm.param_group.param_order">
                  <template v-for="pr in d_selectedWdm[pg].param_order">
                    <template v-if="row['data'] && row['data'][pg] && row['data'][pg][pr] && row['data'][pg][pr]['val']">
                      <template v-if="typeof row['data'][pg][pr]['val'] === 'object'">
                        {{ row['data'][pg][pr]['val'].label }}
                      </template>
                      <template v-else-if="typeof row['data'][pg][pr]['val'] === 'list'">
                        <template v-for="op in row['data'][pg][pr]['val']">
                          {{ op.label }}
                        </template>
                      </template>
                      <template v-else>
                        {{ row['data'][pg][pr]['val'] }}
                      </template>
                    </template>
                  </template>
                </template>
              </template>
            </b-col>
            <b-col sm="12" lg="1">
              <b-button @click="f_editWdmrDocument(row)">düzenle</b-button>
            </b-col>
          </b-row>
        </template> -->
      </b-col>
    </b-row>

    <b-modal v-if="d_editDataModal.show" id="d_editDataModal_show" v-model="d_editDataModal.show" scrollable hide-footer :title="StoreLangTranslation.data['edit'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <div v-if="!d_editDataModal.data['client_id']">
        <b-row>
          <b-col sm="12" lg="9">
            <span>Client id:</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="9">
            <b-form-input type="text" v-model="d_clientId">
            </b-form-input>
          </b-col>
          <b-col sm="12" lg="3">
            <b-button @click="f_addUuid()">
              Add
            </b-button>
          </b-col>
        </b-row>
        <hr/>
      </div>
      <div v-if="d_layerCodeHasParentList.indexOf(d_editDataModal.data_type) !== -1 && !d_editDataModal.data['parent_c']">
        <b-row>
          <b-col sm="12" lg="9">
            <span>Parent client id:</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="9">
            <b-form-input type="text" v-model="d_parentClientId">
            </b-form-input>
          </b-col>
        </b-row>
        <hr/>
      </div>
      <wisdom-data-modal :style="d_layerCodeHasParentList.indexOf(d_editDataModal.data_type) !== -1 && !d_editDataModal.data['parent_c'] && !d_editDataModal.data['client_id'] ? 'max-height: 60vh; overflow-y: auto; overflow-x: hidden;' : d_layerCodeHasParentList.indexOf(d_editDataModal.data_type) !== -1 || !d_editDataModal.data['parent_c'] && !d_editDataModal.data['client_id'] ? 'max-height: 70vh; overflow-y: auto; overflow-x: hidden;' :'max-height: 80vh; overflow-y: auto; overflow-x: hidden;'" :data="d_editDataModal.data" :data_type="d_editDataModal.data_type" :option_data="d_editDataModal.option_data"></wisdom-data-modal>
      <div style="max-height: 10vh;">
        <b-button :disabled="d_isNew && d_layerCodeHasParentList.indexOf(d_editDataModal.data_type) !== -1 && !d_parentClientId ? true : false" @click="f_saveWdmr()" variant="success" style="float: right; margin-left: 5px;">
          {{ StoreLangTranslation.data['save'][StoreLang] }}
        </b-button>
        <b-button @click="f_closeWdmrEditModal()" variant="danger" style="float: right;">
          {{ StoreLangTranslation.data['cancel'][StoreLang] }}
        </b-button>
      </div>
    </b-modal>
    <b-modal v-if="d_showDataModal.show" id="d_showDataModal_show" v-model="d_showDataModal.show" scrollable hide-footer :title="StoreLangTranslation.data['show'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <wisdom-data-show :change="change" :view_mode="'table'" :data="d_showDataModal.data" :data_type="d_showDataModal.data_type" :option_data="d_showDataModal.option_data[d_showDataModal.data_type]"></wisdom-data-show>
    </b-modal>
    <b-modal v-if="d_dbQueryRuleShowModal" id="d_dbQueryRuleShowModal" v-model="d_dbQueryRuleShowModal" scrollable hide-footer :title="StoreLangTranslation.data['create_query_rule'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <div style="min-height: 500px;">
        <wdm-rule-a :data_type="d_dbQueryRule.data_type" :option_data="d_dbQueryRule.option_data" :prepare_data="d_dbQueryRule.prepare_data" :query_list="d_dbQueryRule.query_list" :compile_str_array="d_dbQueryRule.compile_str_array" :compile_str_date="d_dbQueryRule.compile_str_date" :wdmr_change="d_dbQueryRule.wdmr_change" :p_wdmList="d_dbQueryRule.wdm_list" :mother_children="d_dbQueryRule.mother_children" :p_wdmParameterSelectData="d_dbQueryRule.wps_data" :p_wdmRuleAsettings="d_dbQueryRule.wra_settings" :compile_str_text="d_dbQueryRule.compile_str_text"></wdm-rule-a>
        <b-row>
          <b-col sm="12" lg="6"></b-col>
          <b-col sm="12" lg="3">
            <b-button variant="outline-primary" size="sm" @click="d_dbQueryRuleShowModal = false">
              <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['cancel'][StoreLang] }}
            </b-button>
          </b-col>
          <b-col sm="12" lg="3">
            <b-button variant="outline-primary" size="sm" @click="f_acceptMainRule()">
              <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['save'][StoreLang] }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

  </div>
</template>

<script>


import { ClsRule } from '@/wam/modules/rule';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsUser } from '@/wam/modules/user';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as WisdomDataModal
} from '@/wam/components/wdmr/WisdomDataModal';
import {
  default as RuleQuery
} from '@/wam/components/rule/RuleQuery';
import {
  default as WisdomDataShow
} from '@/wam/components/wdmr/WisdomDataShow';
import {
  default as WdmRuleA
} from '@/wam/components/rule/WdmRuleA';
import { mapGetters } from 'vuex';
export default {
  name: 'db',
  computed: mapGetters({
    StoreLang: 'StoreLang',
    StoreLangTranslation: 'StoreLangTranslation',
  }),
  components: {
    WisdomDataModal,
    WisdomDataShow,
    WdmRuleA,
    RuleQuery,
  },
  props: {},
  data () {
    return {
      d_ruleQueryData: '',
      d_temp: {},
      change: '0',
      d_editDataModal: {
        'show': false,
        'data': '',
      },
      d_showDataModal: {
        'show': false,
        'data': '',
      },
      d_selectedWdm: '',
      d_layerCodeList: ['auth', 'log', 'mail', 'phone', 'sysvar', 'usr', 'usr_extky', 'usr_accky', 'usr_accky_tok', 'usr_tok', 'usr_auth', 'usr_shp', 'usr_shp_bund','usr_shp_bund_agr', 'usr_shp_bund_pro', 'usr_shp_bund_pro_agr', 'usr_shpcrt', 'usr_shpcrt_bund', 'usr_shpcrt_bund_pro', 'usr_shpcrt_bund_pro_pay', 'usr_bill','usr_extaccky', 'frd', 'frd_webunit', 'usr_shpcrt_bund_agr', 'usr_shpcrt_bund_pro_agr', 'usr_support', 'document', 'mail_support', 'report', 'ip', 'usr_support_comment', 'mail_support_comment', 'usr_auth_analyzeres'],
      d_layerCodeHasParentList: ['usr_extky', 'usr_accky', 'usr_accky_tok', 'usr_tok', 'usr_auth', 'usr_shp', 'usr_shp_bund', 'usr_shp_bund_agr', 'usr_shp_bund_pro', 'usr_shp_bund_pro_agr', 'usr_shpcrt', 'usr_shpcrt_bund', 'usr_shpcrt_bund_pro', 'usr_shpcrt_bund_pro_pay', 'usr_bill', 'usr_extaccky', 'frd_webunit', 'usr_shpcrt_bund_agr', 'usr_shpcrt_bund_pro_agr', 'usr_support', 'mail_support', 'usr_support_comment', 'mail_support_comment', 'usr_auth_analyzeres'],
      d_dataList: [],
      d_dbQueryRuleShowModal: false,
      d_dataLoading: false,
      d_dbQueryRule: {
        'query_list': [],
        'compile_str_array': '',
        'compile_str_date': '',
        'compile_str_text': '',
      },
      d_selectedLayerCode: '',
      d_prepareRuleNew: {
        'mother_children': {
          'change_status': 0,
          'forceUpdate': 0
        },
        'date_ability': '',
        'wdmr_change': { 'rule': 0 },
        'data_type': '',
        'option_data': {},
        'prepare_data': {},
        'query_list': [],
        'compile_str_date': [],
        'compile_str_text': [],
        'compile_str_array': [],
        'wra_settings': {
          'mode': 'param',
          'options': [
            { 'label': 'PARAM', 'value': 'param' },
            { 'label': 'PARAM & QUERY', 'value': 'param_query' }
          ]
        },
        'wps_data': [{
          'operation': '',
          'selected_value': '',
          'loc': [],
          'val_list': [],
          'selected_wdm': '',
          'd_level': 0,
          'd_level_count': 0,
          'significant': 'true'
        }],
        'wdm_list': [],
      },
      d_wdmLoading: false,
      d_algorithmShow: true,
      d_parentClientId: '',
      d_clientId: '',
      d_isNew: true,
    };
  },
  created: function () {
    this.f_getData();
  },
  beforeMount () {},
  mounted: function () {},
  methods: {
    f_changeAlgorithmShow: function (new_val) {
      this.d_algorithmShow = new_val;
    },
    f_copyClientId: function (clientId) {
      if (!clientId) return;
      navigator.clipboard.writeText(clientId)
        .then(() => {
          // console.log("Client ID kopyalandı:", clientId);
        })
        .catch(err => {
          console.log("error:", err);
        });
    },
    f_addUuid: function () {
      if (this.d_clientId) {
        this.d_clientId += '_';
      }
      this.d_clientId += this.f_uuidv4();
    },
    f_uuidv4: function () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    f_closeWdmrEditModal: function () {
      this.d_editDataModal.show = false;
    },
    f_saveWdmr: function () {
      // console.log('save data: ', this.d_editDataModal.data);
      let query = '';
      query += 'layer_code=' + this.d_selectedLayerCode
      if (this.d_editDataModal.data['client_id']) {
        query += '&cl_id=' + encodeURIComponent(this.d_editDataModal.data['client_id']);
      }
      else if (this.d_clientId) {
        query += '&cl_id=' + encodeURIComponent(this.d_clientId)
      }
      if (this.d_editDataModal.data['parent_c']) {
        query += '&p_id=' + encodeURIComponent(this.d_editDataModal.data['parent_c']['id'])
        // query += '&p_ly_id=' + this.d_editDataModal.data['parent_c']['ly_id']
      }
      else if (this.d_parentClientId) {
        query += '&p_id=' + encodeURIComponent(this.d_parentClientId)
      }
      let data = {
        'wdmr_data': this.d_editDataModal.data,
      };
      console.log(query)
      console.log(data)
      ServiceFunctions.db_record(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            alert("başarılı")
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_selectLayerCode: function (layer_code) {
      this.d_selectedLayerCode = layer_code;
    },
    f_openSearchRuleModal: function () {
      this.d_dbQueryRule = JSON.parse(JSON.stringify(this.d_prepareRuleNew));
      let new_wdm_item = {'type': this.d_selectedLayerCode, 'value': this.d_selectedLayerCode, 'label': this.d_selectedLayerCode};
      this.d_dbQueryRule.wdm_list.push(new_wdm_item);
      this.d_dbQueryRule.option_data[this.d_selectedLayerCode] = this.d_selectedWdm;
      this.$set(this.d_dbQueryRule, 'query_list', this.d_temp.query_list || []);
      this.$set(this.d_dbQueryRule, 'compile_str_array', this.d_temp.compile_str_array || []);
      this.$set(this.d_dbQueryRule, 'compile_str_date', this.d_temp.compile_str_date || []);
      this.$set(this.d_dbQueryRule, 'compile_str_text', this.d_temp.compile_str_text || []);
      this.d_dbQueryRuleShowModal = true;
    },
    f_acceptMainRule: function () {
      let parenthesis_control = ClsRule.f_controlParanthesisDesign(this.d_dbQueryRule.compile_str_array);
      // console.log('parenthesis_control : ', parenthesis_control);
      if (parenthesis_control) {
        if (this.d_dbQueryRule.wra_settings.mode === 'param') {
          ClsRule.f_paramToQuery(this.d_dbQueryRule.query_list, this.d_dbQueryRule.compile_str_array, this.d_dbQueryRule.wps_data);
        }
        this.d_ruleQueryData = {
          'query_list': this.d_dbQueryRule.query_list,
          'compile_str_array': this.d_dbQueryRule.compile_str_array,
          'compile_str_date': this.d_dbQueryRule.compile_str_date,
          'compile_str_text': this.d_dbQueryRule.compile_str_text
        };
        this.d_temp = {
          'query_list': this.d_dbQueryRule.query_list,
          'compile_str_array': this.d_dbQueryRule.compile_str_array,
          'compile_str_date': this.d_dbQueryRule.compile_str_date,
          'compile_str_text': this.d_dbQueryRule.compile_str_text
        };

        let query = '';
        let data = {
          'rule_data': this.d_ruleQueryData,
          'wdmr_list_id': '',
          'wdmr_list_id_count': '',
          'layer_code': this.d_selectedLayerCode,
        };
        this.d_dataLoading = true;
        ServiceFunctions.db_layer_query(query, data)
          .then(resp => {
            this.d_dataList = [];
            this.d_dataLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              for (let i in resp.data.sql_result_list['paramorder']) {
                this.d_dataList.push(resp.data.sql_result_list['parameters'][resp.data.sql_result_list['paramorder'][i]]);
              }
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });

        // console.log('this.d_ruleQueryData ', this.d_ruleQueryData);
        this.d_dbQueryRuleShowModal = false;
      } else {
        alert(this.StoreLangTranslation.data['please_check_parenthesis'][this.StoreLang]);
      }
    },
    f_calculateLayerDetailsTableStyle: function () {
      let style = 'overflow-x: auto; overflow-y: auto; width: 100%; border: solid 1px blue;';
      let height = 'height: ' + (window.innerHeight - 300).toString() + 'px;';
      style += height;
      return style;
    },
    f_editWdmrDocument: function (row) {
      // console.log(row);
      const isNotRow = (row === undefined);  

      if (isNotRow) {
        row = {'data': {}};
        this.d_isNew = true;
      } else {
        this.d_isNew = false;
      }
      this.d_parentClientId = ''
      this.d_clientId = ''
      this.d_editDataModal.data = row;
      this.d_editDataModal.data_type = this.d_selectedLayerCode;
      this.d_editDataModal.option_data = {};
      this.d_editDataModal.option_data[this.d_selectedLayerCode] = this.d_selectedWdm;
      this.d_editDataModal.show = true;
    },
    f_showWdmrDocument: function (row) {
      // console.log(row);
      this.d_showDataModal.data = row;
      this.d_showDataModal.data_type = this.d_selectedLayerCode;
      this.d_showDataModal.option_data = {};
      this.d_showDataModal.option_data[this.d_selectedLayerCode] = this.d_selectedWdm;
      this.d_showDataModal.show = true;
    },
    f_getData: function () {
      if (this.d_selectedLayerCode) {
        this.d_dataList = [];
        let query = 'layer_code=' + this.d_selectedLayerCode;
        let data = {};
        ServiceFunctions.db_data_get(query, data)
          .then(resp => {
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              this.d_dataList = resp.data.list;
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      }
    }
  },
  watch: {
    'd_selectedLayerCode': function () {
      if (!this.d_wdmLoading) {
        this.d_selectedWdm = '';
        this.d_wdmLoading = true;
        ClsWdm.getLayerWdm(this.d_selectedLayerCode).then(resp_wdm_data => { 
          this.d_selectedWdm = resp_wdm_data; 
          this.d_wdmLoading = false;
          this.f_openSearchRuleModal();
        });
        // console.log("d_selectedLayerCode: ",this.d_selectedLayerCode)
        // this.f_getData();
        this.d_dataList = [];
        this.d_temp = {}
      }
    },
    '$route.name': function () {
      // this.f_getData();
    }
  }
}

</script>

